const base = process.env.REACT_APP_API_URL || '';

export const completeOrder = async ({ sessionId, idToken, cartItems, localShipping }) => {
  const res = await fetch(`${base}/api/orders/complete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId, idToken, cartItems, localShipping }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data.error || 'Erro ao salvar pedido');
    err.status = res.status;
    throw err;
  }

  return data;
};

export const fetchMyOrders = async (idToken) => {
  const res = await fetch(`${base}/api/orders/mine`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data.error || 'Erro ao buscar pedidos');
    err.status = res.status;
    throw err;
  }

  return data.orders || [];
};
